export const GET_DATAENTRY_PLANTS = "GET_DATAENTRY_PLANTS"
export const GET_DATAENTRY_PLANTS_SUCCESS = "GET_DATAENTRY_PLANTS_SUCCESS"
export const GET_DATAENTRY_PLANTS_FAIL = "GET_DATAENTRY_PLANTS_FAIL"

export const GET_DATAENTRY_ANIMALS = "GET_DATAENTRY_ANIMALS"
export const GET_DATAENTRY_ANIMALS_SUCCESS = "GET_DATAENTRY_ANIMALS_SUCCESS"
export const GET_DATAENTRY_ANIMALS_FAIL = "GET_DATAENTRY_ANIMALS_FAIL"

export const ADD_DATAENTRY_PLANT = "ADD_DATAENTRY_PLANT"
export const ADD_DATAENTRY_PLANT_SUCCESS = "ADD_DATAENTRY_PLANT_SUCCESS"
export const ADD_DATAENTRY_PLANT_FAIL = "ADD_DATAENTRY_PLANT_FAIL"

export const ADD_DATAENTRY_ANIMAL = "ADD_DATAENTRY_ANIMAL"
export const ADD_DATAENTRY_ANIMAL_SUCCESS = "ADD_DATAENTRY_ANIMAL_SUCCESS"
export const ADD_DATAENTRY_ANIMAL_FAIL = "ADD_DATAENTRY_ANIMAL_FAIL"

export const GET_LEADERBOARD = "GET_LEADERBOARD"
export const GET_LEADERBOARD_SUCCESS = "GET_LEADERBOARD_SUCCESS"
export const GET_LEADERBOARD_FAIL = "GET_LEADERBOARD_FAIL"

